import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeApp, FirebaseError } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfigDevelopment = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const firebaseConfigProduction = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_PRODUCTION,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PRODUCTION,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_PRODUCTION,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PRODUCTION,
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PRODUCTION,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_PRODUCTION,
};

const app = initializeApp(
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? firebaseConfigProduction
    : firebaseConfigDevelopment,
);

export const firestore = getFirestore(app);

export const auth = getAuth(app);

export const storage = getStorage(app);

export const functions = getFunctions(app);

export const firebaseError = FirebaseError;
